export const SET_SHOP_SETTINGS = 'SET_SHOP_SETTINGS';